import { lazy } from 'react';
import PropTypes from 'prop-types';

const Vulnerabilities = lazy(() => import('./components/ToolbarItems/Vulnerabilities'));
const TopServices = lazy(() => import('./components/ToolbarItems/TopServices'));
const TopHosts = lazy(() => import('./components/ToolbarItems/TopHosts'));
const LatestVulns = lazy(() => import('./components/ToolbarItems/LatestVulns'));
const StatusChart = lazy(() => import('./components/ToolbarItems/StatusChart'));
const Feeds = lazy(() => import('./components/ToolbarItems/Feeds'));
const Summary = lazy(() => import('./components/ToolbarItems/Summary'));
const ActivityFeed = lazy(() => import('./components/ToolbarItems/ActivityFeed'));
const WorkspaceDetails = lazy(() => import('./components/ToolbarItems/WorkspaceDetails'));
const CommandHistory = lazy(() => import('./components/ToolbarItems/CommandHistory'));
const Card = lazy(() => import('./components/ToolbarItems/Card'));

// Widgets (V2)
const Remediation = lazy(() => import('./components/Widgets/Remediation'));
const BySeverity = lazy(() => import('./components/Widgets/BySeverity'));
const WorkspaceRisk = lazy(() => import('./components/Widgets/WorkspaceRisk'));
const GeneralLatestFindings = lazy(() => import('./components/Widgets/GeneralLatestFindings'));
const ActivityFeedWidget = lazy(() => import('./components/Widgets/ActivityFeedWidget'));
const FoundVsClosed = lazy(() => import('./components/Widgets/FoundVsClosed'));
const FindingsByAsset = lazy(() => import('./components/Widgets/FindingsByAsset'));

/**
 * Dashboard widget configuration object
 * @typedef {Object} WidgetConfig
 * @property {string} id - WidgetRegistry key to render
 * @property {boolean} visible - Is the widget visible?
 * @property {number} [grow] - Flex grow factor relative to siblings in the same row (default: 1)
 */

/**
 * Validation schema for WidgetConfig objects
 * @type {Object}
 */
export const WidgetConfigPropTypes = {
  id: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  grow: PropTypes.number
};

/**
 * Widget registry
 * id → React Component
 */
const widgetRegistry = {
  vulnerabilities: Vulnerabilities,
  topServices: TopServices,
  topHosts: TopHosts,
  latestVulns: LatestVulns,
  statusChart: StatusChart,
  feeds: Feeds,
  summary: Summary,
  activityFeed: ActivityFeed,
  workspaceDetails: WorkspaceDetails,
  commandHistory: CommandHistory,
  card: Card,
  // Widgets (V2)
  remediation: Remediation,
  bySeverity: BySeverity,
  workspaceRisk: WorkspaceRisk,
  generalLatestFindings: GeneralLatestFindings,
  activityFeedWidget: ActivityFeedWidget,
  foundVsClosed: FoundVsClosed,
  findingsByAsset: FindingsByAsset
};

export default widgetRegistry;
